/**
 * Lenavio Connect — Microsoft Teams integration API client.
 *
 * Mirrors ``backend/app/routers/integrations_teams.py``. The install
 * endpoint returns a JSON authorize URL; the SPA does
 * ``window.location.href = authorize_url`` to follow it (same flow
 * as Slack).
 */
import client from "./client";

export interface TeamsInstallResponse {
  authorize_url: string;
}

export interface TeamsStatusResponse {
  connected: boolean;
  ever_installed: boolean;
  tenant_id: string | null;
  tenant_name: string | null;
  channel_id: string | null;
  installed_at: string | null;
  /** True when an Incoming Webhook URL is configured (URL itself is
   *  a secret and never returned). */
  webhook_configured: boolean;
}

export async function getTeamsInstallUrl(): Promise<TeamsInstallResponse> {
  const res = await client.get<TeamsInstallResponse>(
    "/integrations/teams/install",
  );
  return res.data;
}

export async function getTeamsStatus(): Promise<TeamsStatusResponse> {
  const res = await client.get<TeamsStatusResponse>(
    "/integrations/teams/status",
  );
  return res.data;
}

export async function disconnectTeams(): Promise<TeamsStatusResponse> {
  const res = await client.delete<TeamsStatusResponse>(
    "/integrations/teams/disconnect",
  );
  return res.data;
}

/**
 * Set (or clear, with an empty string) the org's Teams Incoming
 * Webhook URL. The backend validates it's an https Teams connector
 * URL and stores it as a secret (never returned).
 */
export async function setTeamsWebhook(
  webhookUrl: string,
): Promise<TeamsStatusResponse> {
  const res = await client.put<TeamsStatusResponse>(
    "/integrations/teams/webhook",
    { webhook_url: webhookUrl },
  );
  return res.data;
}
